import { Container } from 'react-bootstrap';
import { Upload } from '../FormFields/Upload';
import { useState } from 'react';
import { ControlButtons } from '../ControlButtons';

export const SeismicPlan = ({
	seismicPlan = {},
	onNext = () => {},
	onPrevious = () => {},
	onSubmit = () => {},
	finalStep = false,
	disablePrev = false,
}) => {
	const [currFile, setCurrFile] = useState(seismicPlan.file);
	const [currAnswer, setCurrAnswer] = useState(seismicPlan.answer);
	const disableNext = () => {
		return currAnswer === null || (currAnswer && !currFile);
	};
	return (
		<Container className="component mt-5">
			<Container className="component">
				<h2 className="mb-4">Do you have a Seismic Monitoring Plan?</h2>
				<Upload
					className="mt-4"
					file={currFile}
					setFile={setCurrFile}
					answer={currAnswer}
					setAnswer={setCurrAnswer}
				/>
			</Container>
			<ControlButtons
				onNext={() => onNext({ file: currFile, answer: currAnswer })}
				onPrev={onPrevious}
				onSubmit={onSubmit}
				disablePrev={disablePrev}
				disableNext={disableNext()}
				finalStep={finalStep}
			/>
		</Container>
	);
};
